const en = {
  foo: 'Foo',
  bar: 'Bar {{someValue}}'
}

export default en
